import React from "react";

const LongDownArrow = ({
    width = "16",
    height = "16",
    fill = "none",
    stroke = "#909DFF",
    strokeWidth = "2",
    strokeLinecap = "round",
    strokeLinejoin = "round"
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill={fill}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.33301 12L7.99967 14.6667L10.6663 12"
                stroke={stroke}
                strokeWidth={strokeWidth}
                strokeLinecap={strokeLinecap}
                strokeLinejoin={strokeLinejoin}
            />
            <path
                d="M8 1.33398V14.6673"
                stroke={stroke}
                strokeWidth={strokeWidth}
                strokeLinecap={strokeLinecap}
                strokeLinejoin={strokeLinejoin}
            />
        </svg>
    );
};

export default LongDownArrow;
